import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePermissions } from '../../../shared/PermissionsContext';
import QuickBooksProductsTab from './QuickBooksProductsTab';
import QuickBooksActivityTab from './QuickBooksActivityTab';
import QuickBooksCustomersTab from './QuickBooksCustomersTab';
import QuickBooksMappingsTab from './QuickBooksMappingsTab';
import UnderlinedTabs from './UnderlinedTabs';

// Accounting > QuickBooks (issue #265, vis_quickbooks_integration.md
// "QuickBooks Activity"): the QuickBooks bridge seen from one place — what's
// linked, and what has crossed. Products and Customers are the matching
// tabs; Mappings matches Tax Codes, Payment Terms and the shipping Item
// (issue #264).
// The connection itself stays on Platform > API Integrations (Admin only).

function QuickBooksPage() {
  const { accessFor } = usePermissions();
  // Products follows the Products screen's own permissions; Activity this
  // screen's.
  const productAccess = accessFor('products');
  // Customers follows the Customers screen; its field mapping, this one.
  const customerAccess = accessFor('sales-customers');
  const quickbooksAccess = accessFor('accounting-quickbooks');
  const tabs = [
    ...(productAccess.read ? [{ key: 'products', label: 'Products' }] : []),
    ...(customerAccess.read ? [{ key: 'customers', label: 'Customers' }] : []),
    { key: 'mappings', label: 'Mappings' },
    { key: 'activity', label: 'Activity' },
  ];
  // ?tab= opens on a given tab (e.g. a Sales Order line sending a Product here to link it).
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(tabs.some((t) => t.key === searchParams.get('tab')) ? searchParams.get('tab') : tabs[0].key);

  return (
    <div style={{ margin: '32px 24px 48px', background: '#fafafa', border: '1px solid #eceef1', borderRadius: 12, boxShadow: '0 1px 6px rgba(0,0,0,0.04)', paddingBottom: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px 0' }}>
        <h2 style={{ margin: 0, fontWeight: 600, fontSize: 20 }}>QuickBooks</h2>
      </div>
      <div style={{ margin: '16px 24px 0' }}>
        <UnderlinedTabs tabs={tabs} value={tab} onChange={setTab} />
      </div>
      {tab === 'products' && <QuickBooksProductsTab canEdit={productAccess.update} />}
      {tab === 'customers' && <QuickBooksCustomersTab canEdit={customerAccess.update} canEditMapping={quickbooksAccess.update} />}
      {tab === 'mappings' && <QuickBooksMappingsTab canEdit={quickbooksAccess.update} />}
      {tab === 'activity' && <QuickBooksActivityTab />}
    </div>
  );
}

export default QuickBooksPage;
